/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Seo: any = ({ description, lang, meta, noIndex, title, ogImage, shouldTitleSkipFindDocPostfix }) => {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    );
    
    const useTitlePostfix = !(shouldTitleSkipFindDocPostfix ?? false);
    const metaDescription = description || site.siteMetadata.description;
    const defaultTitle = site.siteMetadata?.title;
    const isNoIndex = noIndex ?? false;

    const og: any = {
        image: ogImage || site.siteMetadata.ogImage,
        type: 'image/jpeg',
        width: '1200',
        height: '600',
    }

    const seoKeywords = metaDescription;

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={(useTitlePostfix && defaultTitle) ? `%s | ${defaultTitle}` : null}
            meta={[    
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: og.type,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata?.author || ``,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ].concat(meta)}
        >

            { isNoIndex && <meta name="robots" content="noindex"/>}

            <meta property="og:locale" content="zh_HK" />
            <meta property="og:type" content="website"></meta>
            <meta property="og:image" content={og.image} />
            <meta property="og:image:width" content={og.width} />
            <meta property="og:image:height" content={og.height} />

            <meta property="title" content={title}></meta>
            <meta property="og:title" content={title}></meta>

            <meta property="description" content={metaDescription}></meta>
            <meta property="og:description" content={metaDescription}></meta>

            <meta property="keywords" content={seoKeywords}></meta>
            <meta property="DC.subject" content={seoKeywords}></meta>

            <link rel="icon" href="https://www.finddoc.com/favicon.ico?v=1" sizes="32x32" />
            <meta name="theme-color" content="#4A90E2" />
        </Helmet>
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
